import * as Action from '../action';

export default (state = {}, action) => {
  switch (action.type) {
    case Action.SET_EXPORT_DO_LIST:
      return { ...action.exportDoList };
    default:
      return state;
  }
};
